import * as React from "react";
import { Helmet } from "react-helmet";

interface IProps {
  // One schema.org object, or several (each is rendered as its own
  // <script type="application/ld+json"> tag).
  data:
    | Record<string, any>
    | Array<Record<string, any>>
    | false
    | null
    | undefined;
}

// Renders schema.org structured data as JSON-LD <script> tags in <head>,
// via react-helmet so it survives the Prerender.io snapshot just like the
// rest of the site's meta tags.
// Uses Helmet's `script` prop (array-of-objects form) rather than JSX
// children, matching the approach already used in Metadata.tsx - adding
// <script> as a Helmet child can cause intermittent rangeErrors,
// see https://github.com/nfl/react-helmet/issues/373
const StructuredData = ({ data }: IProps) => {
  const items = (Array.isArray(data) ? data : [data]).filter(
    (item): item is Record<string, any> => Boolean(item)
  );

  if (items.length === 0) {
    return null;
  }

  return (
    <Helmet
      script={items.map((item) => ({
        type: "application/ld+json",
        innerHTML: JSON.stringify(item),
      }))}
    />
  );
};

export default StructuredData;
